import React from 'react'

import { DispensaryContextProvider } from '../components/dispensaries/DispensaryContextProvider'
import { useDispensarySlug } from '../lib/dispensaries/hooks/useDispensarySlug'
import { SanitySiteContext } from '../lib/sanity/context'
import { SanityContext } from '../lib/sanity/context-based-content'
import { DispensaryPageEffects } from './dispensaries/DispensaryPageEffects'
import { LoadingPageProps } from './LoadingPage'

export const DispensaryPageAdapter: React.FC<{
  loadingPageComponent: React.ComponentType<LoadingPageProps>
  page: React.ReactElement
}> = ({ loadingPageComponent, page }) => {
  const slug = useDispensarySlug()

  return !slug ? (
    page
  ) : (
    <SanitySiteContext.Provider value={SanityContext.Dispensary}>
      <DispensaryContextProvider slug={slug}>
        <DispensaryPageEffects loadingPageComponent={loadingPageComponent}>
          {page}
        </DispensaryPageEffects>
      </DispensaryContextProvider>
    </SanitySiteContext.Provider>
  )
}
